module.exports = __webpack_public_path__ + "static/img/mode-media@2x.95340d91.png";